import { GoogleLogin } from "@react-oauth/google";
import { googleSignIn } from "@/lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
// Sign in with Google via the app owner's own OAuth client (REACT_APP_GOOGLE_CLIENT_ID). The browser receives a Google
// ID token; the backend verifies it against Google and issues the app's normal token. Renders nothing when not configured.
export const GOOGLE_CLIENT_ID = (process.env.REACT_APP_GOOGLE_CLIENT_ID || "").trim();

export function GoogleSignInButton({ asRole = "", onAuthed, onError }) {
  if (!GOOGLE_CLIENT_ID) return null;
  return (
    <div data-testid="google-signin" className="space-y-2">
      <div className="flex items-center gap-3 text-[11px] uppercase tracking-[0.18em] text-stone-400">
        <span className="h-px flex-1 bg-stone-200" />or<span className="h-px flex-1 bg-stone-200" />
      </div>
      <div className="flex justify-center">
        <GoogleLogin
          text="continue_with"
          shape="rectangular"
          onSuccess={async (resp) => {
            try {
              const data = await googleSignIn({ credential: resp.credential, as_role: asRole });
              onAuthed(data);
            } catch (e) {
              const d = e?.response?.data?.detail;
              onError?.(typeof d === "string" ? d : "Google sign-in didn't work. Please try again.");
            }
          }}
          onError={() => onError?.("Google sign-in was cancelled or failed.")}
        />
      </div>
    </div>
  );
}
